import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} CameraEventComment
 * @property {string} [commentId]    - Camera event comment id
 * @property {string} [eventId]      - Camera event id
 * @property {string} [userId]       - User id that left the comment
 * @property {string} [creationTime] - The time when the comment was created in ISO8601 UTC format.
 * @property {string} [lastModified] - The time when the comment was updated in ISO8601 UTC format.
 * @property {string} [comment]      - Event comment text
 */
export const cameraEventCommentPropType = PropTypes.shape({
    commentId: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    creationTime: iso8601PropType,
    lastModified: iso8601PropType,
    comment: PropTypes.string.isRequired
})
